import React from 'react';
import { markEnglishRewardJoined } from '../../../utils/englishRewardApi';
import {
  canJoinSpecialistBooking,
  formatSpecialistShortName,
  formatSpecialistSlot,
  specialistSessionPhase,
  splitSpecialistBookings,
} from '../../../utils/specialistBookingDisplay';
import './SpecialistSessions.css';

const statusLabel = (booking, phase) => {
  if (booking.status === 'cancelled') return 'Cancelled';
  if (booking.status === 'cancelled_late') return 'Cancelled late';
  if (booking.status === 'missed') return 'Missed';
  if (booking.status === 'completed') return 'Attended';
  if (phase === 'live') return 'Live now';
  if (phase === 'past') return 'Awaiting specialist';
  return 'Scheduled';
};

const openSession = async (booking) => {
  if (booking.id) {
    try {
      await markEnglishRewardJoined(booking.id);
    } catch {
      // Still open Meet even if attendance tracking fails.
    }
  }
  if (booking.meetLink) {
    window.open(booking.meetLink, '_blank', 'noopener,noreferrer');
  }
};

const SessionRow = ({ booking, past }) => {
  const phase = specialistSessionPhase(booking);
  const joinable = !past && canJoinSpecialistBooking(booking);
  const status = booking.status || 'scheduled';
  const chipClass = phase === 'live' ? 'is-live' : `is-${status}`;
  return (
    <li
      className={`specialist-sessions__row ${
        past ? 'is-past' : phase === 'live' ? 'is-live' : 'is-upcoming'
      }`}
    >
      <div className="specialist-sessions__copy">
        <strong className="specialist-sessions__when">
          {formatSpecialistSlot(booking.slotStart)}
        </strong>
        <div className="specialist-sessions__meta">
          {formatSpecialistShortName(booking.teacherName) ? (
            <span className="specialist-sessions__teacher">
              {formatSpecialistShortName(booking.teacherName)}
            </span>
          ) : null}
          <span className={`specialist-sessions__status ${chipClass}`}>
            {statusLabel(booking, phase)}
          </span>
        </div>
      </div>
      {joinable ? (
        <button
          type="button"
          className="specialist-sessions__join"
          onClick={() => openSession(booking)}
        >
          Join session
        </button>
      ) : null}
    </li>
  );
};

const SpecialistSessions = ({ bookings = [] }) => {
  const { upcoming, past } = splitSpecialistBookings(bookings);
  if (!upcoming.length && !past.length) return null;

  return (
    <div className="specialist-sessions">
      {upcoming.length > 0 && (
        <section>
          <h4>Upcoming specialist sessions</h4>
          <ul>
            {upcoming.map((booking) => (
              <SessionRow key={booking.id || booking.slotStart} booking={booking} />
            ))}
          </ul>
        </section>
      )}
      {past.length > 0 && (
        <section>
          <h4>Past specialist sessions</h4>
          <ul>
            {past.map((booking) => (
              <SessionRow
                key={booking.id || `past-${booking.slotStart}`}
                booking={booking}
                past
              />
            ))}
          </ul>
        </section>
      )}
    </div>
  );
};

export default SpecialistSessions;
